import { render, staticRenderFns } from "./SilderBar.vue?vue&type=template&id=2303031b&scoped=true"
import script from "./SilderBar.vue?vue&type=script&lang=js"
export * from "./SilderBar.vue?vue&type=script&lang=js"
import style0 from "./SilderBar.vue?vue&type=style&index=0&id=2303031b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2303031b",
  null
  
)

export default component.exports